export default "__VITE_ASSET__D4TE5r86__"